module.exports = __webpack_public_path__ + "media/images/sme-banner-d897fed5c2f242ade411b0b2cbc79a2a.jpg";